<div class="suggestion-notify-float" *ngIf="suggestions.active"><xqnr-suggestion-notify></xqnr-suggestion-notify></div>